import { createSelector } from "reselect";
import _ from "lodash";

export const alfBy = (sel, key) =>
  createSelector([sel], vals => _.sortBy(vals, key));



// WEBPACK FOOTER //
// ./src/components/selectors.js